module.exports = __webpack_public_path__ + "media/customizations/fieldslife/logo-416557a0b1062bc7a847f571fc1e2d28.png";